import { createSelector } from 'reselect';

import { IServicePeriod } from '../../types/reducers/publishTerms';
import { selectPublishTerms } from './selectPublishTerms';

export const selectActivePeriod = createSelector(
  selectPublishTerms,
  ({ periodsByService, selectedPeriodId, selectedServiceId }): IServicePeriod | null => {
    const periodsInfo = !!selectedServiceId && periodsByService[selectedServiceId];

    if (!selectedPeriodId || !periodsInfo) {
      return null;
    }

    return periodsInfo.periods[selectedPeriodId] || null;
  },
);
